import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiMail, FiTrash2, FiEye, FiSearch } from 'react-icons/fi';
import { UseToast } from '../../hooks/UseToast';
import Badge from '../../components/ui/Badge';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const ContactMessageList = () => {
  const navigate = useNavigate();
  const toast = UseToast();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => { fetchMessages(); }, []);

  const fetchMessages = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/messages/all`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        setMessages(data.data || []);
      }
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this message?')) return;
    try {
      const token = localStorage.getItem('token');
      const res = await fetch(`${API_URL}/messages/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.success) {
        toast.success('Deleted');
        setMessages(prev => prev.filter(m => m._id !== id));
      }
    } catch (err) { toast.error('Delete failed'); }
  };

  const filtered = messages.filter(m => 
    m.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    m.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    m.phone?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    m.subject?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <style>{`
        .messages-page { font-family: 'Outfit', sans-serif; }
        .page-header { margin-bottom: 30px; display: flex; justify-content: space-between; align-items: center; }
        .page-title { font-size: 32px; font-weight: 800; color: #0F172A; margin:0; }
        .filters-bar { background: #FFF; padding: 20px; border-radius: 16px; box-shadow: 0 4px 20px rgba(0,0,0,0.06); margin-bottom: 24px; display: flex; gap: 16px; }
        .search-input { flex: 1; display: flex; align-items: center; gap: 10px; background: #F1F5F9; padding: 12px 16px; border-radius: 10px; }
        .search-input input { border: none; background: none; outline: none; flex: 1; font-family: inherit; }
        .messages-list { background: #FFF; border-radius: 16px; box-shadow: 0 4px 20px rgba(0,0,0,0.06); overflow: hidden; }
        .message-item { padding: 20px 24px; border-bottom: 1px solid #F1F5F9; display: flex; align-items: center; gap: 16px; cursor: pointer; }
        .message-item:hover { background: #F8FAFC; }
        .message-icon { width: 48px; height: 48px; border-radius: 12px; background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%); display: flex; align-items: center; justify-content: center; color: #FFF; }
        .message-actions { display: flex; gap: 8px; }
        .action-btn { width: 36px; height: 36px; border-radius: 8px; border: none; display: flex; align-items: center; justify-content: center; cursor: pointer; }
        .action-btn-view { background: #DBEAFE; color: #3B82F6; }
        .action-btn-delete { background: #FEE2E2; color: #EF4444; }
      `}</style>

      <div className="messages-page">
        <div className="page-header">
          <div>
            <h1 className="page-title">Contact Messages</h1>
            <p style={{color:'#64748B'}}>Total {messages.length} messages</p>
          </div>
          <Badge color="#3B82F6" bg="#DBEAFE">{messages.length} Total</Badge>
        </div>

        <div className="filters-bar">
          <div className="search-input">
            <FiSearch />
            <input placeholder="Search by name, email, phone, subject..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
          </div>
        </div>

        <div className="messages-list">
          {loading ? <div style={{padding:60, textAlign:'center'}}>Loading...</div> :
            filtered.map(msg => (
              <div key={msg._id} className="message-item" onClick={() => navigate(`/contact-messages/${msg._id}`)}>
                <div className="message-icon"><FiMail /></div>
                <div style={{flex:1}}>
                  <div style={{fontWeight:700}}>{msg.name} <span style={{fontWeight:400, color:'#64748B', fontSize:13, marginLeft:8}}>{msg.phone}</span></div>
                  <div style={{color:'#3B82F6', fontWeight:600, fontSize:14}}>{msg.subject} • {msg.email}</div>
                  <div style={{color:'#64748B', fontSize:13, whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis', maxWidth:500}}>{msg.message}</div>
                </div>
                <div className="message-actions">
                  <button className="action-btn action-btn-view" onClick={e => { e.stopPropagation(); navigate(`/contact-messages/${msg._id}`)}}><FiEye /></button>
                  <button className="action-btn action-btn-delete" onClick={e => { e.stopPropagation(); handleDelete(msg._id)}}><FiTrash2 /></button>
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </>
  );
};

export default ContactMessageList;